import { Trans, useTranslation } from "react-i18next";
import { ParallaxBanner } from "react-scroll-parallax";
import patrickPankalla from "../assets/images/patrick_pankalla.jpg";

const AdvantagesSection = () => {
  const { t } = useTranslation();

  return (
    <section>
      <div className="lg:mt-8">
        <ParallaxBanner
          layers={[{ image: patrickPankalla, speed: -30 }]}
          className="w-screen h-96"
        >
          <div className="max-w-5xl mx-8 md:mx-auto absolute z-10 inset-0 flex flex-col items-center justify-center text-white">
            <div className="font-Roboto text-3xl leading-9 lg:text-4xl lg:leading-11 mb-4 text-center">
              <Trans>
								Unsere jährliche CO2 Einsparung entspricht den Emissionen, die
								bei der
              </Trans>
            </div>
            <a
              href="https://www.carbon-connect.ch/index.cfm/de/co2-emissionen-autoproduktion/"
              className="underline cursor-pointer text-xs leading-4"
              target="_blank"
              rel="noreferrer"
            >
							*https://www.carbon-connect.ch/index.cfm/de/co2-emissionen-autoproduktion/
            </a>
          </div>
          <div className="bg-[#1D4376] h-full w-full absolute top-0 mix-blend-multiply" />
        </ParallaxBanner>
      </div>
      <div className="max-w-screen-xl mx-4 flex flex-col mt-16 lg:flex-row lg:items-start lg:gap-x-8 2xl:mx-auto">
        <div>
          <h2 className="text-4xl leading-10 font-Roboto font-bold mb-8">
            <Trans>Die Vorteile von Hydro REDUXA</Trans>
          </h2>
          <ul className="ml-8 mb-8 list-square">
            <li className="font-Roboto">
              <Trans>
								Ausschließliche Nutzung von Energie aus erneuerbaren Quellen
              </Trans>
            </li>
            <li className="font-Roboto">
              <Trans>
								Maximal 4,0 kg CO2e/kg Aluminium, einschließlich aller
								Prozessschritte (Scope 1, 2 und 3)
              </Trans>
            </li>
            <li className="font-Roboto">
              <Trans>RÜCKVERFOLGBAR bis zu jeder einzelnen Charge</Trans>
            </li>
            <li className="font-Roboto">
              <Trans>Zertifiziert von DNV-GL nach ISO 14064</Trans>
            </li>
            <li className="font-Roboto">
              <Trans>BESTÄTIGT durch Umwelt-Produktdeklarationen</Trans>
            </li>
            <li className="list-square font-Roboto">
              <Trans>
								Zertifiziert von der Aluminium Stewardship Initiative
              </Trans>
            </li>
          </ul>
          <p className="font-Roboto">
            {t(
              "Hydro ist an jedem Schritt der Wertschöpfungskette beteiligt und kann so dafür sorgen, dass der gesamte Prozess immer nachhaltiger wird. Für die Produktion von Hydro Low Carbon werden ausschließlich erneuerbare Energien aus eigenen Wasserkraftwerken von Hydro verwendet.",
            )}
          </p>
        </div>
        <div className="mt-11 shrink-0 border lg:w-2/4 xl:w-[750px] xl:h-[391px] lg:mt-0">
          <video
            className="w-full h-full lg:object-fill xl:object-cover"
            controls
          >
            <source src={"./hydro_reduxa.mp4"} type="video/mp4" />
            <track src="" kind="captions" label="German" />
          </video>
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
